import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { routes } from './project.routes';
import { ProjectDetailComponent } from './project-detail.component';
import { ProjectService } from './project.service';
import { ProductionOfficeComponent } from './production-office.component';
import { ProductionContactComponent } from './production-contact.component';
import { ProjectContactComponent } from './project-contact.component';
import { AppService } from '../app.service';

import { AssetManagerModule } from "../shared/asset-manager.module";
import { TooltipCleanerDirective } from '../shared/tooltip-cleaner.directive';
import { SharedModule } from '../shared/shared.module';
import { ProjectListComponent } from './project-list/project-list.component';
import { UserDepartmentService } from '../user-department/user-department.service';
import { ProjectStatusComponent } from './project-status.component';
import { StatusService } from '../status/status.service';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { TextFieldModule } from '@angular/cdk/text-field';

@NgModule({
  declarations: [
    ProjectDetailComponent,
    ProductionOfficeComponent,
    ProductionContactComponent,
    ProjectContactComponent,
    ProjectListComponent,
    TooltipCleanerDirective,
    ProjectStatusComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    AssetManagerModule,
    SharedModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    TextFieldModule,
  ],
  providers: [
    ProjectService,
    UserDepartmentService,
    StatusService
  ]
})
export class ProjectModule {
  public static routes = routes;
}
